/* eslint-disable react/prop-types */
import React, {useEffect} from 'react';
import removeWhiteSpace from '../../constants/removeSpace';
import {CBForm} from '../../constants/apricotCBform';
import {ADMIN_ROLE} from '../../constants/global';
import '../SmartDisplay/SmartDisplay.scss';
import './TextInput.scss';
import {ToolTip} from '../';
import { lockMsg, lockMsgAdmin } from '../../constants/messages';

const TextInput = props => {

  const {apcp, question_tooltip, inputId, halfInput, inputType, inputLabel, requiredInput,
    inputName, textvalue, org_rol, errorId, onChangeInputValue, inputSize, minLength, maxLength,
    successMsg='Success', errMsg='Error', readOnly, showQlock, children} = props;

  useEffect(() => {
    document.querySelectorAll('.cb-floating-label').forEach(elem => {
      CBForm.floatingLabel(elem.querySelector('input'));
    });
  }, []);

  return(
    <div id={`${errorId}_one`} className='fieldArrangement'>
      <div className='cb-input cb-input-condensed col-md-12 fieldInput'>
        <div id={`${errorId}_two`} className='cb-validation-label-input'>
          <div className={`display-flex ${halfInput?'col-md-12':'col-md-6'}`} >
            {children}
            <label className={`${requiredInput?'cb-required':''}`} htmlFor={`text`+removeWhiteSpace(inputId)}>{inputLabel}</label>
            {
              !apcp&&question_tooltip?<ToolTip tooltipid={`smartdisplaytextinput${removeWhiteSpace(inputId)}id`} 
                                        tooltipMsg={question_tooltip} 
                                        innerMsg={<span className="cb-icon cb-user"></span>} 
                                        className={'questionToolTip'}
                                        />
                                        :''
            }
          </div>
          <div className={`lineupinput ${halfInput?'col-md-12':'col-md-6'}`}>
            <input type={`${inputType}`} id={`text${removeWhiteSpace(inputId)}`}
              name={inputName}
              className='opentextinput'
              value={textvalue}
              autoComplete='off'
              aria-invalid='false'
              disabled={readOnly}
              aria-readonly={readOnly}
              aria-describedby=''
              aria-required={requiredInput}
              data-testid={inputId}
              size={inputSize}
              maxLength={maxLength}
              minLength={minLength}
              onChange={event => {
               onChangeInputValue(event.target.value);
              }} />
              {showQlock?
                <ToolTip tooltipid={`texttooltip${inputId}`} 
                tooltipMsg={org_rol===ADMIN_ROLE?lockMsgAdmin:lockMsg} 
                className={'cb-icon cb-lock'} />:''
              }
          </div>
        </div>
      </div>
      <div className='errorDiv'>
        <p id={`${errorId}_s`} style={{display: 'none'}}>{successMsg}</p>
        <p id={`${errorId}_e`} style={{display: 'none'}}>{errMsg}</p>
      </div>
    </div>
  );
};

export default TextInput;